import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForUpdateUser from './ModalForUpdateUser';
import Tooltip from '@material-ui/core/Tooltip';

class UserRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  onDeactivateClick = (id) => {
    const action = () => {
      this.props.deactivateUser(id);
    };
    confirmDialog(
      this.props.t.ConfirmDialog.deactivateUserMessage,
      action,
      this.props.t.ConfirmDialog.deactivate,
      this.props.gt
    );
  };

  onActivateClick = (id) => {
    const action = () => {
      this.props.activateUser(id);
    };
    confirmDialog(
      this.props.t.ConfirmDialog.activateUserMessage,
      action,
      this.props.t.ConfirmDialog.activate,
      this.props.gt
    );
  };

  showModal = () => {
    this.props.findAllKjs();
    this.setState({
      show: true,
    });
  };

  handleEdit = (user, message) => {
    this.props.updateUser(user, this.handlePreviewClose, message);
  };

  handlePreviewClose = () => {
    this.setState({
      show: false,
      showUpdatePassword: false,
    });
    this.props.clearKjsList();
  };

  onDeleteClick = (id) => {
    const action = () => {
      this.props.deleteUser(id);
    };
    const translation = this.props.t.ConfirmDialog;
    confirmDialog(
      translation.deleteUserMessage,
      action,
      translation.confirmDelete,
      this.props.gt
    );
  };

  activateDeactivateUser = (id, onClick, title, iconClassName) => {
    return (
      <td className="text-center">
        <Link id={id} onClick={onClick} to="#">
          <Tooltip title={title} placement="top" arrow={true}>
            <i className={iconClassName} />
          </Tooltip>
        </Link>
      </td>
    );
  };

  render() {
    const { user, error } = this.props || {};

    let row = (
      <tr>
        <td>{this.props.index}</td>
        <td>{user.firstName}</td>
        <td>{user.lastName}</td>
        <td>{user.username}</td>

        {user.active ? (
          <td className="text-center">
            <i className="fas fa-check"></i>
          </td>
        ) : (
          <td className="text-center">
            <i className="fas fa-times"></i>
          </td>
        )}

        {user.active
          ? this.activateDeactivateUser(
              'dectivateUser',
              () => this.onDeactivateClick(user.id),
              this.props.t.Tooltips.deactivate,
              'fas fa-times-circle fa-2x'
            )
          : this.activateDeactivateUser(
              'ctivateUser',
              () => this.onActivateClick(user.id),
              this.props.t.Tooltips.activate,
              'fas fa-play-circle fa-2x'
            )}

        <td className="text-center" id="centerRow">
          <Link onClick={this.showModal} to="#">
            <i className="fas fa-edit fa-2x" />
          </Link>
        </td>
      </tr>
    );
    return (
      <Fragment>
        {row}
        {this.state.show && (
          <ModalForUpdateUser
            show={this.state.show}
            user={user}
            handleEdit={this.handleEdit}
            handleClose={this.handlePreviewClose}
            error={error}
            deleteError={this.props.deleteError}
            rolesHashMapList={this.props.rolesHashMapList}
            autonomousProvinceList={this.props.autonomousProvinceList}
            placeList={this.props.placeList}
            municipalityList={this.props.municipalityList}
            kjsList={this.props.kjsList}
            institutionTypeList={this.props.institutionTypeList}
            findAllPlaceByAutonomousProvince={
              this.props.findAllPlaceByAutonomousProvince
            }
            findAllMunicipalityByPlace={this.props.findAllMunicipalityByPlace}
            findAllKjsByInstitutionType={this.props.findAllKjsByInstitutionType}
            findAllPlaceWithoutAutonomousProvince={
              this.props.findAllPlaceWithoutAutonomousProvince
            }
            clearPlaceList={this.props.clearPlaceList}
            clearMunicipalityList={this.props.clearMunicipalityList}
            clearKjsList={this.props.clearKjsList}
            findAllPlace={this.props.findAllPlace}
            changeComboAutocomplete={this.changeComboAutocomplete}
            organizationalUnit={this.state.organizationalUnit}
            autonomousProvince={this.state.autonomousProvince}
            place={this.state.place}
            municipality={this.state.municipality}
            institutionType={this.state.institutionType}
            kjs={this.state.kjs}
            findAllKjs={this.props.findAllKjs}
            findAllKjsFilterPageable={this.props.findAllKjsFilterPageable}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(UserRow, 'UserRow');
